import { getToken } from '../utils/token-util'
import { localClear } from '../utils/local-util'
import { Toast } from 'antd-mobile'
import { createFetchInstance } from './fetch-utils'

let initialized = false

// 基础请求地址
const hostname = window.location.hostname
const apiUrlMap = {
  localhost: 'https://1.gqjys.co',
  '206.238.199.169': 'https://1.gqjys.co',
}
export const BASE_API_URL = apiUrlMap[hostname] ? apiUrlMap[hostname] : window.location.origin
export const BASE_IMG_URL = BASE_API_URL.replace(':1025', '')

const TOKEN_HEADER = 'x-access-token'
const outPath = [
  '/',
  '/login',
  '/login-page',
  '/pc-home',
  '/download',
  '/reloadpassword',
  '/reloadpassword2',
  '/downloadInfo',
  '/register',
  '/homecenter',
  '/murmurchat',
  '/chatcenter',
  '/changelanguage',
]

const fetchInstance = createFetchInstance()
fetchInstance.init(() => {

  fetchInstance.addRequestMiddleware(async (config, meta) => {
    // 添加请求头和参数处理
    const token = getToken();
    let language = localStorage.getItem('i18n');
    let companyIdStr = localStorage.getItem('companyId');
    let userCode = localStorage.getItem('userCode');

    if (!language) {
      language = 'en';
    }

    // 创建新的headers对象
    const headers = new Headers(config.headers);

    // 创建请求参数对象
    let params = {};

    // 创建请求体对象
    let bodyData = {};
    if (config.body) {
      try {
        bodyData = JSON.parse(config.body.toString());
      } catch (e) {
        // 如果body不是JSON格式，保持原样
      }
    }

    // 添加语言参数
    if (language) {
      params['language'] = language;
      bodyData['language'] = language;
    }

    // 添加userCode参数
    if (userCode) {
      params['userCode'] = userCode;
      bodyData['userCode'] = userCode;
    }

    // 添加token
    if (token) {
      headers.set(TOKEN_HEADER, token);
      params['token'] = token;
      bodyData['token'] = token;
    } else {
      // 判断是否需要跳转
      if (!outPath.includes(window.location.pathname)) {
        Toast.show({
          content: 'Please login',
          duration: 1000,
        });
        setTimeout(() => {
          window.location.href = '/login-page';
        }, 1000);
        return config;
      }
    }

    // 添加公司ID
    if (companyIdStr && companyIdStr !== '' && companyIdStr !== 'undefined') {
      const companyId = parseInt(companyIdStr);
      params['companyId'] = companyId;
      bodyData['companyId'] = companyId;
    }

    // 更新请求配置
    const updatedConfig = {
      ...config,
      headers,
    };

    // 更新URL参数（对于GET请求）
    if (config.method === 'GET' || config.method === 'get') {
      const url = new URL(config.url, BASE_API_URL);
      Object.keys(params).forEach((key) =>
        url.searchParams.append(key, params[key])
      );
      updatedConfig.url = url.toString().replace(BASE_API_URL, '');
    }

    // 更新请求体（对于POST请求）
    if (
      (config.method === 'POST' || config.method === 'post') &&
      Object.keys(bodyData).length > 0
    ) {
      updatedConfig.body = JSON.stringify(bodyData);
    }

    meta.fetchParams = params;

    updatedConfig.baseUrl = BASE_API_URL;

    return updatedConfig;
  });

  fetchInstance.addErrorMiddleware((err, config) => {
    console.error(`[fetch error] ${config.method} ${config.url}`, err);

    // 处理错误响应
    if (err.response) {
      const res = err.response;

      // 处理响应状态和数据
      if (res.data && res.data.code) {
        // Token过期或账号在别处登录
        if (res.data.code === 30007) {
          Toast.show({
            content: 'Please login',
            duration: 1000,
          });
          localClear();
          setTimeout(() => {
            window.location.href = '/';
          }, 300);
        }
      }
    } else {
      // 网络错误或其他错误
      Toast.show({
        content: 'error',
        icon: 'fail',
        duration: 1000,
      });
    }

    return err;
  });
  
})

const { useFetch, createFetchClient, defineRequest, refreshApi } =
  fetchInstance;

export { useFetch, createFetchClient, defineRequest, refreshApi };